export class GCPortalkarteDefaultValuesClass {
    /**
     *
     */
    public fillColor: string = 'blue';
    /**
     *
     */
    public strokeColor: string = 'blue';
    public strokeWidth: number = 2;
    public radius: number = 5;

    public anchor: [number, number] = [0.5, 1.0];
    public opacity: number = 1.0;
    public padding: [number,number,number,number] = [20,20,20,20];
    public maxZoom: number = 14;
    public maxZoomSteps: number = 20;
    public minZoomSteps: number = 5;
    public maxGeocoderZoom: number = 0;

    public duration: number = 200;
    public extentPaddingFactor: number = 10;
    public testValue: number = 0;

    public mapBackground: string = 'topplus';
    public mapStartpoint: [number,number] = [11,51];
    public mapStartzoom: number = 10;
    public mapWidth: number = 400;
    public mapHeight: number = 400;
    public mapDynamic: number = 0;
    public mapDefaultPointIconPath: string = '/res/modules/portalkarte/icon/0313-location.svg';
    public mapDefaultPointIconColor: string = '#0080C0';
    public mapDefaultPointIconOpacity: number = 0.8;
    public mapDefaultPointIconAnchor: [number,number] = [0.5, 1.0];
    public mapCtrlOptions: any = {};

    public mapViewProjection: any = 'EPSG:3857'; // EPSG:900913

}